export const MORE_DATA_BTN_LABEL = "More data";
export const DETAILS_BTN_LABEL = "Details";
